import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { PasswordInput } from "../components/ui/PasswordInput";
import { Gift, Smartphone } from "lucide-react";
import { toast } from "sonner";

export default function CustomerLogin() {
  const { loginCustomer } = useAuth();
  const navigate = useNavigate();
  const [whatsapp, setWhatsapp] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await loginCustomer(whatsapp, password);
      toast.success(`¡Bienvenido${user?.name ? `, ${user.name}` : ""}!`);
      navigate("/mi-cuenta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto px-4 sm:px-6 py-6 sm:py-12">
        <div className="inline-flex items-center gap-2 bg-[#EDE9FE] border border-[#C4B5FD] text-[#5B21B6] text-xs px-3 py-1 rounded-full font-semibold">
          <Gift className="w-3.5 h-3.5" /> Acceso clientes
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-3">Bienvenido de vuelta</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          Accede a tu cuenta para ver tus puntos y recompensas.
        </p>

        <form onSubmit={submit} className="mt-6 bg-white border border-border rounded-2xl p-4 sm:p-6 space-y-4" data-testid="customer-login-form">
          <div>
            <Label className="text-sm">Celular</Label>
            <div className="mt-1.5 relative">
              <Smartphone className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input
                required
                inputMode="numeric"
                className="pl-9"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value.replace(/\D/g, "").slice(0, 10))}
                placeholder="5512345678"
                data-testid="customer-login-whatsapp"
              />
              {whatsapp.length > 0 && whatsapp.length < 10 && (
                <p className="text-[11px] text-amber-600 mt-1">{whatsapp.length}/10 dígitos — faltan {10 - whatsapp.length}</p>
              )}
              {whatsapp.length === 10 && (
                <p className="text-[11px] text-green-600 mt-1">✓ Número completo</p>
              )}
            </div>
          </div>
          <div>
            <Label className="text-sm">Contraseña</Label>
            <PasswordInput
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5"
              placeholder="Tu contraseña"
              data-testid="customer-login-password"
            />
          </div>
          <Button type="submit" disabled={busy} className="w-full btn-primary rounded-full py-6" data-testid="customer-login-submit">
            {busy ? "Entrando…" : "Entrar"}
          </Button>
          <div className="text-sm text-center">
            <Link to="/recuperar-contrasena?rol=customer" className="text-muted-foreground hover:text-zinc-800 hover:underline" data-testid="customer-forgot-password">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
          <div className="text-sm text-center text-muted-foreground">
            ¿No tienes cuenta? <Link to="/registro-cliente" className="text-[hsl(var(--primary))] font-medium">Regístrate gratis</Link>
          </div>
          <div className="text-xs text-center text-muted-foreground pt-2 border-t border-border">
            ¿Eres comercio? <Link to="/login" className="text-zinc-700 hover:underline font-medium">Inicia sesión aquí</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
